import { CalendarDays } from 'lucide-react';
import { useEvents } from '../context/EventContext';
import { Select } from './UI';
import { fmtDate } from '../utils/format';

/**
 * The event selector that heads every operational screen. Reads and writes the
 * shared EventContext so the choice follows the user between pages.
 */
export default function EventPicker({ style }) {
  const { events, eventId, setEventId } = useEvents();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 9, ...style }}>
      <CalendarDays size={15} color="var(--gold-500)" style={{ flexShrink: 0 }} />
      <Select
        value={eventId}
        onChange={(e) => setEventId(e.target.value)}
        style={{ minWidth: 250, padding: '9px 32px 9px 12px' }}
        aria-label="Select event"
      >
        {!events.length && <option value="">No events available</option>}
        {events.map((e) => (
          <option key={e._id} value={e._id}>
            {e.title} · {fmtDate(e.startDate)}
          </option>
        ))}
      </Select>
    </div>
  );
}
